<div (click)="toggleDropdown(); $event.stopPropagation()" [class.disabled]="disabled" [style.width]="width" class="dropdown">
  <button [attr.disabled]="disabled ? true : null" [class.open]="isOpen" [class.placeholderText]="!selectedItem" [ngStyle]="selectedItemDisplayStyle" class="dropdown-btn" role="button" type="button">
    {{ displayValue }}
    <span>
      @if (isOpen) {
        <app-icon color="var(--slate-gray)" iconName="chevron-up" size="16px"></app-icon>
      } @else {
        <app-icon color="var(--slate-gray)" iconName="chevron-down" size="16px"></app-icon>
      }
    </span>
  </button>
  @if (isOpen && !disabled) {
    <div
      [ngClass]="{
        'dropdown-content': true,
        top: dropdownPosition === 'top',
        bottom: dropdownPosition === 'bottom' || dropdownPosition === 'auto',
      }"
      [ngStyle]="dropdownContentStyle"
      class="dropdown-content"
    >
      @for (item of options; track item) {
        <div
          (click)="selectItem(item)"
          [ngClass]="isItemSelected(item) ? (selectedItemClass ? selectedItemClass : 'selected-item') : ''"
          [ngStyle]="Object.assign({}, itemsStyle || {}, isItemSelected(item) ? selectedItemInListStyle || {} : {})"
          class="dropdown-item"
        >
          <div class="icon">
            @if (isItemSelected(item)) {
              <app-icon color="var(--orange)" iconName="check" planeIcon="true" size="20px"></app-icon>
            }
          </div>
          {{ getDisplayName(item) }}
        </div>
      }
    </div>
  }
</div>
